var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 6.6C21.6 8.58823 17.302 10.2 12 10.2C6.69809 10.2 2.40002 8.58823 2.40002 6.6M21.6 6.6C21.6 4.61177 17.302 3 12 3C6.69809 3 2.40002 4.61177 2.40002 6.6M21.6 6.6V17.4C21.6 19.3882 17.302 21 12 21C6.69809 21 2.40002 19.3882 2.40002 17.4V6.6M21.6 12C21.6 13.9882 17.302 15.6 12 15.6C6.69809 15.6 2.40002 13.9882 2.40002 12",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.1d87579db75104d4fd4d693733aa16da.svg";
export { ForwardRef as ReactComponent };